import React, { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { SHARE_ROUTE } from 'src/constants/routes';
import * as analytics from 'src/utils/analytics';

import { BirthDatePicker } from './BirthDatePicker';
import css from './HeroForm.module.scss';
import { parseISO } from 'date-fns';

const texts = {
  submit: 'לתוצאות >>',
};

export const HeroForm = () => {
  const navigate = useNavigate();
  const [birthDate, setBirthDate] = useState('');
  const scrollTargetRef = useRef<HTMLDivElement>(null);

  const handleDatePickerOpen = useCallback((isOpen: boolean) => {
    if (isOpen) {
      scrollTargetRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!birthDate) return;

    analytics.onResultsClick(parseISO(birthDate));
    navigate(`${SHARE_ROUTE}?d=${birthDate}`);
  };

  return (
    <form className={css.form} onSubmit={handleSubmit}>
      <BirthDatePicker value={birthDate} onChange={setBirthDate} onOpen={handleDatePickerOpen} />

      <button className={css.submit} type="submit" disabled={!birthDate}>
        {texts.submit}
      </button>
      <div ref={scrollTargetRef} />
    </form>
  );
};
